
import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Webcam from 'react-webcam';
import * as blazeface from '@tensorflow-models/blazeface';
import '@tensorflow/tfjs';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SetCheckInOutAction, SetCheckInOutputMethosAction, SetFaceVerificationAction } from "../../../../Redux/Slice";
import axios from "axios";
import { PresentUrl } from "../../../../text/apidata";
import { store } from "../../../../Redux/Store";
import BackImage from "../../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";
import { useNavigate } from 'react-router-dom';


var CheckingAttendancesResult = false;
const CheckInOut = () => {
  const webcamRef = useRef(null);
  const canvasRef = useRef(null);
  const [model, setModel] = useState(null);
  const [selfie, setSelfie] = useState(null);
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const [FILE, setImgFile] = useState(null);

  const stateDisplay = useSelector((state) => state.SideBarActive.SidebarActive);
  const [isWithinRadius, setIsWithinRadius] = useState(false);

  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [errorMessage, setErrorMessage] = useState("");
  const [PresentUrls, setPresentUrls] = useState([]);
  const [presenturlInUrl, seturlandfile] = useState({
    file: "",
    url: ""
  })
  const navigate = useNavigate("");


  // Load the BlazeFace model
  const loadModel = async () => {
    try {
      const loadedModel = await blazeface.load();
      setModel(loadedModel); // This will trigger a re-render once the model is loaded
      console.log("Model loaded successfully:", loadedModel);
    } catch (error) {
      console.error("Error loading the model:", error);
    }
  };

  const capture = React.useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    getGeolocation()
    setSelfie(imageSrc);
    const file = dataURLtoFile(imageSrc, "webcam_photo.jpg");

    const generateRandomNumber = () => {
      return Math.floor(Math.random() * 100000);
    };
    const createPresentData = (file) => {
      const randomNumber = generateRandomNumber();
      const formattedFilename = `onboarding/user_image/user_image${randomNumber}.${file.type.split('/')[1]}`; // Use the file's extension
      const Presentdata = {
        multiple_files: [
          {
            filename: formattedFilename,
            file_type: file.type,
          },
        ],
      };

      return Presentdata;
    };
    const Presentdata = createPresentData(file);
    axios({
      url: PresentUrl,
      method: 'post',
      data: Presentdata,
      headers: {
        Authorization:
          "Bearer " +
          store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
      },
    })
      .then((response) => {
        const uploadedFiles = response.data.data;
        const newUrls = uploadedFiles.map(urls => ({
          url: urls,
          type: file.type,
          putfiles: file

        }));

        setPresentUrls(newUrls);
        seturlandfile({
          url: String(response.data.data).split("?")[0]
        })
        setImgFile(file);

        // fetchUploadUserImage()
        console.log(newUrls, "New urls ,newUrls");


        try {
          const response = fetch(newUrls[0].url, {
            method: 'PUT',
            headers: {
              'Content-Type': newUrls[0].type,
              "x-amz-acl": "public-read"
            },
            body: newUrls[0].putfiles,
          });
          console.log("sdasd asdasd");
        } catch (error) {
          console.error('Error uploading files:', error);
        }

      })
      .catch((error) => {
        console.error('Error uploading files:', error);
      });
  }, [webcamRef, setSelfie]);

  function dataURLtoFile(dataurl, filename) {
    // Decode the data URL
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  const getGeolocation = () => {

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const latitude = position.coords.latitude;
          const longitude = position.coords.longitude;
          setLocation({ latitude, longitude });

          const branchLatitude = state.UDSemployeeRoleActions?.Branch?.latitude;
          const branchLongitude =
            state.UDSemployeeRoleActions?.Branch?.longitude;

          console.log(branchLatitude, "ASA SpoAIS ASdistance");


          if (!state.UDSemployeeRoleActions.white_collar) {
            if (branchLatitude != null && branchLongitude != null) {
              const distance = calculateDistance(
                latitude,
                longitude,
                branchLatitude,
                branchLongitude
              );

              console.log(distance, "wqpewe pqowie distance ");
              if (state.CustomUDSEMployeeLogin.CustomoginDATAs.data.data.user_role.white_collar === false) {

                setIsWithinRadius(distance <= 1000); // 1000 meters radius
                console.log(distance <= 1000, "qwpiepqwe pqowieq e", isWithinRadius);

                CheckingAttendancesResult = distance <= 1000;

                if (CheckingAttendancesResult === true) {
                  toast.success(
                    "You are within 1000 meters of the branch location.",
                    {
                      position: toast.POSITION.TOP_RIGHT,
                    }
                  );
                } else if (CheckingAttendancesResult === false) {
                  toast.error(
                    "You are outside the 1000 meters radius of the branch location.",
                    {
                      position: toast.POSITION.TOP_RIGHT,
                    }
                  );

                  setErrorMessage("You are outside the 1000 meters radius of the branch location")
                }
              }
            }
          }
        },
        (error) => {
          console.error("Error retrieving location:", error);
          setErrorMessage(
            "Unable to retrieve your current location. Please ensure location services are enabled and try again."
          );
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
      setErrorMessage("Geolocation is not supported by this browser.");
    }
  };
  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const toRadians = (degrees) => degrees * (Math.PI / 180);
    const R = 6371e3; // Earth radius in meters

    const dLat = toRadians(lat2 - lat1);
    const dLon = toRadians(lon2 - lon1);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRadians(lat1)) *
      Math.cos(toRadians(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    const distance = R * c; // Distance in meters
    return distance;
  };

  const branchLatitude = state.UDSemployeeRoleActions?.Branch.latitude;
  const branchLongitude = state.UDSemployeeRoleActions?.Branch.longitude;

  // Coordinates of a user exactly 1000 meters away
  const userLatitude = location.latitude;
  const userLongitude = location.longitude;

  const distance = calculateDistance(userLatitude, userLongitude, branchLatitude, branchLongitude);



  // const detectFaces = async () => {
  //   if (webcamRef.current && model) {
  //     const video = webcamRef.current.video;

  //     if (video.readyState === 4) {
  //       const predictions = await model.estimateFaces(video, false);

  //       const displaySize = { width: video.videoWidth, height: video.videoHeight };
  //       const context = canvasRef.current.getContext('2d');
  //       canvasRef.current.width = displaySize.width;
  //       canvasRef.current.height = displaySize.height;

  //       context.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);

  //       // Draw face detections
  //       predictions.forEach((prediction) => {
  //         const [startX, startY] = prediction.topLeft;
  //         const [endX, endY] = prediction.bottomRight;

  //         context.strokeStyle = 'green';
  //         context.lineWidth = 2;

  //         // Adjust the rectangle drawing to fit correctly
  //         const boxWidth = endX - startX;
  //         const boxHeight = endY - startY;

  //         context.strokeRect(startX, startY, boxWidth, boxHeight);
  //       });
  //     }
  //   }
  // };



  const detectFaces = async () => {
    if (webcamRef.current && model && canvasRef.current) {
      const video = webcamRef.current.video;

      if (video.readyState === 4) {
        const predictions = await model.estimateFaces(video, false);

        const displaySize = { width: video.videoWidth, height: video.videoHeight };
        if (canvasRef.current != null) {
          const context = canvasRef.current.getContext('2d');
          canvasRef.current.width = displaySize.width;
          canvasRef.current.height = displaySize.height;

          context.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);

          // Draw face detections
          predictions.forEach((prediction) => {
            const [startX, startY] = prediction.topLeft;
            const [endX, endY] = prediction.bottomRight;

            context.strokeStyle = 'green';
            context.lineWidth = 2;

            // Adjust the rectangle drawing to fit correctly
            const boxWidth = endX - startX;
            const boxHeight = endY - startY;

            context.strokeRect(startX, startY, boxWidth, boxHeight);
          });
        }
      }
    }
  };


  useEffect(() => {
    loadModel();
  }, []);


  useEffect(() => {
    // Start the detection only after the model is loaded
    if (model) {
      const interval = setInterval(() => {
        detectFaces();
      }, 100); // Run detection every 100ms

      // Clean up the interval when the component unmounts or model changes
      return () => clearInterval(interval);
    }
  }, [model]); // Only run this effect when the model is set
  const form_data = new FormData();
  console.log(presenturlInUrl, "presenturlInUrl");

  const handleSubmit = () => {
    var a = 1;
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const hours = String(currentDate.getHours()).padStart(2, "0");
    const minutes = String(currentDate.getMinutes()).padStart(2, "0");
    const seconds = String(currentDate.getSeconds()).padStart(2, "0");
    console.log(state.UDSemployeeRoleActions, "CHECKINKEY");
    if (!state.UDSemployeeRoleActions.white_collar) {
      if (errorMessage != "") {

        a = 1;
      }
    }

    if (state.SideBarFiles.UDSEmployeeeImage != null) {

      if (state.CustomUDSEMployeeLogin.CustomoginDATAs.data.data.user_role.white_collar === false) {
        if (isWithinRadius === true) {
          // const fullUrl = "https://apionboarding.uds.in/media/user_image/webcam_photo_Lv3Wsjo.jpg";
          const fullUrl = state.SideBarFiles.UDSEmployeeeImage;
          const url = new URL(fullUrl);
          const path = url.pathname.substring(1); // Remove the leading slash

          const formdatasEmp = new FormData();
          const CheckingformINEMP = new FormData();
          const CheckOutFormOUTEMP = new FormData();
          formdatasEmp.append("known_image_path",
            state.SideBarFiles.UDSEmployeeeImage.includes("s3") ? state.SideBarFiles.UDSEmployeeeImage : path,

          );
          //File
          formdatasEmp.append("verification_image_path", presenturlInUrl.url)

          CheckingformINEMP.append("data", JSON.stringify({
            year: year,
            month: month,
            date: `${year}-${month}-${day}`,
            check_out_time: `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`,
            user_id: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
              .id,

            // check_in: true,
            // user_id: userId,
            // latitude: location.latitude,
            // longitude: location.longitude,
          }))
          CheckingformINEMP.append("user_image", FILE)
          CheckOutFormOUTEMP.append("data", JSON.stringify({
            year: year,
            month: month,
            date: `${year}-${month}-${day}`,
            check_in_time: `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`,
            user_id: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
              .id,

            // check_in: true,
            // user_id: userId,
            // latitude: location.latitude,
            // longitude: location.longitude,
          }))

          CheckOutFormOUTEMP.append("user_image", FILE)

          const payload = {
            formData: formdatasEmp,
            Methods: state.UDSemployeeRoleActions.CHECKINKEY,
            DATAS: state.UDSemployeeRoleActions.CHECKINKEY == true ? {
              year: year,
              month: month,
              date: `${year}-${month}-${day}`,
              check_out_time: `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`,
              user_id: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
                .id,
              user_image: presenturlInUrl.url
            } : {
              year: year,
              month: month,
              date: `${year}-${month}-${day}`,
              check_in_time: `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`,
              user_id: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
                .id,
              user_image: presenturlInUrl.url

            },
            form_data: state.UDSemployeeRoleActions.CHECKINKEY == true ? {
              Post: false,
              id: state.UDSemployeeRoleActions.AttendanceID,
            } : {
              Post: true,
            },
            Navigatedto: 1,


          }
          dispatch(SetFaceVerificationAction(payload))
        }
        else {
          toast.error(
            "You are outside the 1000 meters radius of the branch location.",
            {
              position: toast.POSITION.TOP_RIGHT,
            }
          );



        }
      }
      else {
        // const fullUrl = "https://apionboarding.uds.in/media/user_image/webcam_photo_Lv3Wsjo.jpg";
        //  const fullUrl = "https://apionboarding.uds.in/media/user_image/swetha.jpg";
        //          const fullUrl = "https://apionboarding.uds.in/media/user_image/swetha.jpg";

        // const url = new URL(fullUrl);
        // const path = url.pathname.substring(1); // Remove the leading slash

        // const formdatas = new FormData();
        // const Checkingform = new FormData();
        // const CheckOutForm = new FormData();
        // formdatas.append("known_image_path",
        //   state.SideBarFiles.UDSEmployeeeImage.includes("s3") ? path : path,

        // );
        const fullUrl = state.SideBarFiles.UDSEmployeeeImage;
        const url = new URL(fullUrl);
        const path = url.pathname.substring(1); // Remove the leading slash

        const formdatas = new FormData();
        const Checkingform = new FormData();
        const CheckOutForm = new FormData();
        formdatas.append("known_image_path",
          state.SideBarFiles.UDSEmployeeeImage.includes("s3") ? state.SideBarFiles.UDSEmployeeeImage : path);

        // formdatas.append("verification_image_path", FILE)

        formdatas.append("verification_image_path", presenturlInUrl.url)


        Checkingform.append("data", JSON.stringify({
          year: year,
          month: month,
          date: `${year}-${month}-${day}`,
          check_out_time: `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`,
          // check_in: true,
          // user_id: userId,
          latitude: location.latitude,
          longitude: location.longitude,
          user_id: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
            .id,

        }))
        Checkingform.append("user_image", FILE)
        CheckOutForm.append("data", JSON.stringify({
          year: year,
          month: month,
          date: `${year}-${month}-${day}`,
          check_in_time: `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`,
          // check_in: true,
          // user_id: userId,
          latitude: location.latitude,
          longitude: location.longitude,
          user_id: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
            .id,

        }))

        CheckOutForm.append("user_image", FILE)

        const payload = {
          formData: formdatas,
          Methods: state.UDSemployeeRoleActions.CHECKINKEY,
          DATAS: state.UDSemployeeRoleActions.CHECKINKEY == true ? {
            year: year,
            month: month,
            date: `${year}-${month}-${day}`,
            check_out_time: `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`,
            // check_in: true,
            // user_id: userId,
            latitude: location.latitude,
            longitude: location.longitude,
            user_id: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
              .id,
            user_image: presenturlInUrl.url


          } : {
            year: year,
            month: month,
            date: `${year}-${month}-${day}`,
            check_in_time: `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`,
            // check_in: true,
            // user_id: userId,
            latitude: location.latitude,
            longitude: location.longitude,
            user_id: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
              .id,
            user_image: presenturlInUrl.url

          },
          form_data: state.UDSemployeeRoleActions.CHECKINKEY == true ? {
            Post: false,
            id: state.UDSemployeeRoleActions.AttendanceID,
          } : {
            Post: true,
          },
          Navigatedto: 1,



        }
        dispatch(SetFaceVerificationAction(payload))

      }

    }


    else {
      toast.error(
        "Kindly upload profile Image",
        {
          position: toast.POSITION.TOP_RIGHT,
        }
      );
    }

    // navigate("/customudsemployee");
  };

  return (
    <div className={stateDisplay ? 'outterContent' : 'inner-Content'}>
      <div className="row ButtonPrevious Filters"
        style={{
          padding: "4px 4px",
          margin: "0px",
          position: "relative",
          zIndex: "30",
          marginLeft: "0px",
          marginRight: "0px",
        }}>
        <div className="col">
          <button
            className="btn BackImga"
            onClick={(e) => {
              navigate("/customudsdashboard");
            }}
          >
            <img className="PreviousPages" src={BackImage} />
            <span></span>

          </button>
        </div>

      </div>


      <div
        className='CheckoutingPopupDesigns'
        style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
        {!selfie && (

          <div className="checkInOutWrapperCamera" style={{
            position: 'relative',
            width: '640px', height: '480px'
            //  width:"50%",
            //  height:"50%"
          }}>
            <>

              <Webcam
                ref={webcamRef}
                audio={false}
                style={{
                  position: 'relative',
                  width: '100%',
                  height: '100%',
                }}
                onUserMediaError={(error) => {
                  alert("No camera detected or access denied. Please ensure a camera is connected.");
                  console.error("Camera error:", error);
                  // setIsModalOpen(false)
                }}
              />


              <canvas
                ref={canvasRef}
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                }}
              />
              <button
                className="customButton ButtonCSS"
                onClick={capture}
                style={{ background: "#F05B39" }}
              >
                Capture
              </button>
            </>

          </div >)}
        {selfie && (
          <dvi className="bottomSection">
            <div>
              {/* <h2>Selfie Preview:</h2> */}
              <img src={selfie} alt="Selfie" />
            </div>
            <div className='Submissionbtn' style={{ display: "flex", justifyContent: "space-between", marginTop: "16px" }}>
              <button
                className="customButton ButtonCSS"
                onClick={() => {
                  setSelfie(null);
                }}
                style={{ background: "#F05B39" }}
              >
                Recapture
              </button>
              <button
                className="customButton ButtonCSS"
                onClick={handleSubmit}
                style={{ background: "#F05B39" }}
              >
                Submit
              </button>
            </div>
          </dvi>
        )}
        {/* {location.latitude && location.longitude && (
          <div>
            <h2>Geolocation</h2>
            <p>Latitude: {location.latitude}</p>
            <p>Longitude: {location.longitude}</p>
          </div>
        )} */}
      </div >
    </div >


  );
};

export default CheckInOut;

